export class FilterItemModel {
    filterProperty: string;
    filterValues: string[];

    constructor(init?: Partial<FilterItemModel>) {
        Object.assign(this, init);
    }
}
